<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('sectionparameter_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-file-cog-outline</v-icon>{{ item['name'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-sectionparameter-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('name') }}</strong></td>
              <td>
                                    {{ item['name'] }}
              </td>

              <td><strong>{{ $t('bracket') }}</strong></td>
              <td>
                                    {{ item['bracket'] }}
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('softwareVersion') }}</strong></td>
              <td>
                                    {{ item['softwareVersion'].name }}
              </td>

              <td></td>
            </tr>

          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';

const servicePrefix = 'SectionParameter';

export default {
  name: 'SectionParameterShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar
  },
  mixins: [ShowMixin,AccessMixin],
  computed: {
    ...mapFields('sectionparameter', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('sectionparameter', ['find'])
  },
  methods: {
    ...mapActions('sectionparameter', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    })
  }
};
</script>
